export default "That's it! We hope you enjoyed this section on generative models, and the workshop as a whole.\n\nThanks so much for coming :)\n"